<app-header>
  @if (showBreadcrumbs()) {
    <bit-breadcrumbs slot="breadcrumbs">
      <bit-breadcrumb [route]="['/settings']" icon="bwi-cog">{{
        "settings" | i18n
      }}</bit-breadcrumb>
      <bit-breadcrumb [route]="[]" queryParamsHandling="preserve">{{
        "addPlan" | i18n
      }}</bit-breadcrumb>
    </bit-breadcrumbs>
  }
</app-header>

<bit-container>
  <p>{{ "newOrganizationDesc" | vfo1I18n: "addPlanDesc" }}</p>
  <app-organization-plans
    [enableSecretsManagerByDefault]="secretsManager"
    [initialPlan]="plan"
    [initialProductTier]="productTier"
    [trialLength]="trialLength"
    [initiationPath]="initiationPath"
  ></app-organization-plans>
</bit-container>
